'use client';
import { motion, type MotionValue } from 'framer-motion';
import { Cimage } from '@/components/ui/Cimage';
import { WITNESS_CARD_ANIMATED_IMAGE_STYLE, WITNESS_CARD_ANIMATED_IMAGE_WRAPPER_STYLE, WITNESS_CARD_STATIC_IMAGE_STYLE, WITNESS_CARD_STATIC_IMAGE_WRAPPER_STYLE, } from './cwitnesscardStyles';
import { CWITNESSCARD_EASE_CURVE } from './cwitnesscardConstants';
import type { WitnessCardData } from './Cwitnesscard.types';
interface StaticWitnessCardImageProps {
    data: WitnessCardData;
}
interface AnimatedWitnessCardImageProps {
    brightnessFilter: MotionValue<string>;
    data: WitnessCardData;
    imageWrapperOpacity: MotionValue<number>;
    imageWrapperY: MotionValue<number>;
    isHovered: boolean;
}
export function StaticWitnessCardImage({ data, }: StaticWitnessCardImageProps) {
    return <div style={WITNESS_CARD_STATIC_IMAGE_WRAPPER_STYLE}>
            <div style={WITNESS_CARD_STATIC_IMAGE_STYLE}>
                <WitnessCardImageContent data={data}/>
            </div>
        </div>
        ;
}
export function AnimatedWitnessCardImage({ brightnessFilter, data, imageWrapperOpacity, imageWrapperY, isHovered, }: AnimatedWitnessCardImageProps) {
    return <motion.div style={{
            ...WITNESS_CARD_ANIMATED_IMAGE_WRAPPER_STYLE,
            filter: brightnessFilter,
            overflow: 'hidden',
            y: imageWrapperY,
            opacity: imageWrapperOpacity,
        }}>
            <motion.div style={WITNESS_CARD_ANIMATED_IMAGE_STYLE} animate={{ scale: isHovered ? 1.03 : 1 }} transition={{ duration: 0.6, ease: [0.25, 0.1, 0.25, 1] }}>
                <WitnessCardImageContent data={data}/>
            </motion.div>
        </motion.div>
        ;
}
function WitnessCardImageContent({ data }: StaticWitnessCardImageProps) {
    return (<Cimage src={data.imageSrc} alt={data.title} static={true} objectFit="cover" width="100%" height="100%" style={{
            width: '100%',
            height: '100%',
            display: 'block',
        }}/>);
}
